export class MpaInterceptedResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "actionApprovalRequest",
            "baseName": "actionApprovalRequest",
            "type": "MpaRequest",
            "format": ""
        },
        {
            "name": "mpaPolicies",
            "baseName": "mpaPolicies",
            "type": "MpaPoliciesInfo",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MpaInterceptedResponse.attributeTypeMap;
    }
    constructor() {
    }
}
